import React from 'react'
import HeroBanner from '../components/Hero Banner/HeroBanner'
import CardBlog from "../components/CardBlog/CardBlog"
import TestimonialForm from '../components/TestimonialForm/TestimonialForm'
import FaqSection from '../components/FaqSection/FaqSection'
import CenteredText from "../components/CenteredText/CenteredText"
import InadmissibleText from '../components/InadmissibleText/InadmissibleText'
import BgImageContent from '../components/BgImageContent/BgImageContent'
import { Helmet } from 'react-helmet'

const faqData = [
    {
        title:"Can I Apply to the Canadian Experience Class Program From Outside of Canada?",
        content:"No, it is not possible to apply for the Canadian Experience Class (CEC) program if you are not in Canada. This program was created for people who have obtained skilled work experience in Canada and who want to apply for permanent residency there."
    },
    {
        title:"Is Proof of Funds Required for Canadian Experience Class?",
        content:"Proof of funds is not necessary for the Canadian Experience Class (CEC) program. This is because applicants who have Canadian work experience are assumed to have already settled in Canada and are assumed to be able to take care of their finances."
    },
    {
        title:"Does Internship Experience in Canada Count Towards My Canadian Experience Class Application?",
        content:"Yes, interning in Canada can be counted towards your application to the Canadian Experience Class (CEC) as long as it meets the requirements of the program."
    },
]

const listData1 =[
    {
        title:"Work Experience",
        content:"To be eligible to apply, a candidate must have had at least one year of full-time or an equal amount of part-time work experience in a skilled occupation in Canada within the last three years. Skilled occupations are classified as National Occupation Classification (NOC) skill type 0, A, or B."
    },
    {
        title:"Language Proficiency",
        content:"A potential applicant must meet the language proficiency standards in either English or French. These standards are evaluated based on standardized tests that have been authorized by the Canadian government. To qualify for the Canadian Experience Class program the minimum language proficiency is Canadian Language Benchmark (CLB) 7 for NOC skill type 0 or A, and CLB 5 for NOC skill type B."
    },
    {
        title:"Education",
        content:"There is no strict educational requirement, but having a Canadian post-secondary degree or diploma can improve one’s chances of being chosen. Education also has the potential to raise a candidate’s Comprehensive Ranking System (CRS) score under the Express Entry system."
    },
    {
        title:"Admissibility",
        content:"A potential applicant must not have any criminal history, health problems, or other reasons that would prevent them from obtaining permanent residency in Canada."
    },
]
const listData2 =[
    {
        title:"Determine your language proficiency",
        content:"Complete a standardized language test in either English (IELTS or CELPIP) or French (TEF). Then enter your scores into the CRS calculator. Points will be granted based on your skill level in reading, writing, speaking, and listening in either English or French."
    },
    {
        title:"Calculate your work experience",
        content:"Provide information regarding your Canadian work experience, such as the type of job, how long you worked in Canada, and your skill level (NOC skill type 0, A, or B). Depending on the length of your work experience in Canada, you will receive points."
    },
    {
        title:"Age",
        content:"Enter your age, and you will receive points based on your age at the time of application."
    },
    {
        title:"Adaptability",
        content:"In order to make settling in Canada easier, there are additional factors you can take advantage of, such as having a spouse or partner who is proficient in the language, having prior study or work experience in Canada, or having a job offer in Canada."
    },
]

function canadianExpressClass() {
  return (
    <>
     <Helmet>
        <title>Canadian Experience Class - VCIC Immigration</title>
        <meta name="description" content='Here is an overview of the Canadian Experience Class program. Look at the eligibility requirements and start a free assessment!' />
        <link rel="canonical" href="https://www.vcicimmigration.com/canadian-experience-class"></link>
   </Helmet>
    <HeroBanner
        Heading="Canadian Experience Class :"
        spanHeading=" A Path to Permanent Residency in Canada for Skilled Workers"
        subHeading=""
        postParagraph=''
        Paragraph="Trust us to guide your transition to permanent residency, leveraging your Canadian work or study experience to build a thriving future."
        btnText=""
        bgImg="/images/creatives/cec-hero-bg.png"
        darkBg={true}
        headingCenter={true}
        btn={false}
        socialLinks={false}
        serviceForm={false}
        isChevron={true}
    />



    <CenteredText
        heading="A Path "
        spanHeading="to Permanent Residency in Canada for Skilled Workers"
        content={"The Canadian Experience Class (CEC) program may be the best way for skilled workers who already have work experience in Canada to get permanent residency in Canada. The Canadian Experience Class is a federal immigration program that aims to make it easier for skilled workers who have worked in Canada to get permanent residency. \n The fact that the Canadian Experience Class takes into account the work experience you already have in Canada is one of the main benefits. This can help increase your chances of getting permanent residency. The Canadian Experience Class is also eligible for Express Entry, which allows skilled workers to immigrate to Canada in the quickest and most effective manner. \n You must meet certain requirements in order to be considered for the Canadian Experience Class. These requirements include demonstrating a sufficient level of language proficiency in either English or French and having at least 12 months of full-time (or an equivalent amount of part-time) skilled work experience in Canada within the three years preceding your application. \n The Canadian Experience Class is a great option for skilled workers who want to move up to permanent residency in Canada after gaining work experience in the country. In comparison to other immigration programs, it allows for a quicker processing time and takes into account your Canadian work experience. \n The Canadian Experience Class is a great option to think about if you want to make Canada your permanent home. Canada is the ideal location to establish a new life and begin your journey toward a better future because of its robust economy, high standard of living, and multicultural society. \n In conclusion, skilled workers who already have work experience in Canada can take advantage of the Canadian Experience Class, a pathway to permanent residency in Canada. The Canadian Experience Class can assist you in achieving your goal of becoming a permanent resident of Canada by expediting your application and taking into account your work experience in Canada."}
        btn={true}
        btnText="BOOK A 30 MINUTE FREE CONSULTATION"
        btnRef="/book-a-free-call"
    />

    <div style={{marginTop:"80px"}}></div>

    <InadmissibleText
        shiftRow={false}
        heading={"How To Overcome"}
        spanHeading={" Inadmissibility In Canada?"}
        img="/images/creatives/cec-text-1.png"
        content1="To be eligible for the Canadian Experience Class (CEC) program, a candidate must meet the following criteria:"
        postHeading=""
        content2=""
        listPoint={listData1}
        topHeading={false}
    />

    <CenteredText
        heading="What are the "
        spanHeading="requirements for Canadian Experience Class?"
        content={"In addition to all the requirements, applicants must also submit an Express Entry profile and be invited to apply (ITA) for permanent residency. \n This ITA is based on the candidate’s CRS score, which is determined through things such as age, education, work experience, language proficiency, and other elements. The CEC program provides an expedited route to permanent residency for eligible applicants who have Canadian work experience."}
        btn={false}
    />

    <div style={{marginTop:"80px"}}></div>

    <InadmissibleText
        shiftRow={true}
        heading={"How to Calculate Your "}
        spanHeading={"Canadian Experience Class CRS Points?"}
        img="/images/creatives/cec-text-2.png"
        content1="In order to calculate your Comprehensive Ranking System (CRS) points for the Canadian Experience Class (CEC) program, you must first qualify for the program. Once you have verified that you meet the requirements, you can set up an Express Entry profile and use the CRS calculator to input your details."
        postHeading=""
        content2=""
        listPoint={listData2}
        topHeading={false}
    />

    <CenteredText
        heading=""
        spanHeading=""
        content={"Once you have inputted all your data, the CRS calculator will provide you with a score out of a possible 1,200 points. Individuals who attain the highest CRS points are more apt to be invited to apply for permanent residency through the Canadian Experience Class program."}
        btn={true}
        btnText="BOOK A 30 MINUTE FREE CONSULTATION"
        btnRef="/book-a-free-call"
    />

    <BgImageContent
         heading="Do you have the required work experience? Get in touch with our immigration consultant!"
         img="/images/creatives/bussiness-immigration-bg.jpg"
         content={""}
         smallContent='We Will Assess Your Profile For Free And Guide You Through The Immigration Process.'
         btn={true}
         btnText ="START ASSESSMENT"
         btnRef="/start-your-free-initial-assessment"
    />

    <FaqSection
        heading="Frequently Asked Questions"
        subHeading="Still have questions?"
        showImg={true}
        faqData={faqData}
    />

    <TestimonialForm/>
    <CardBlog/>
    
</>
  )
}

export default canadianExpressClass